import { IndividualWithBirthNameType } from "../../types/commonTypes/individualWithBirthNameType";

export const initialIndividualWithBirthNameState: IndividualWithBirthNameType = {
    civility: "Monsieur",
    firstName: "",
    lastName: "",
    postalCode: "",
    city: "",
    address: "",
    additionalAddress: "",
    registrationOffice: "",
    birthName: "",
    cities: []
}